import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  isUpperCase16ivdixranflt as isUpperCase,
  uppercaseChar6lahngw3wvwg as uppercaseChar,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  get_serializableAnnotations1rie2dpj7h2ce as get_serializableAnnotations,
  StringValue3s88kmb638dp as StringValue,
  ArrayValue2wekmi4tq7xrl as ArrayValue,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/VirtualType.mjs';
import {
  substringBefore3n7kj60w69hju as substringBefore,
  substringAfterLast3r0t0my8cpqhk as substringAfterLast,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { titleCase1rwupo9lkd0x6 as titleCase } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/casing.mjs';
import {
  firstOrNullf6vlo6vdgu1e as firstOrNull,
  take3onnpy6q7ctcz as take,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { get_DefaultUriFormat2bqsbberx5mh8 as get_DefaultUriFormat } from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/serialization.mjs';
import {
  Companion_instance1blhtv320q15h as Companion_instance,
  DataClassPath2zx7tvblx35e3 as DataClassPath,
  DataClassPathSelf18kqeagzkbefr as DataClassPathSelf,
  DataClassPathAccess3qupo9g6dhbeb as DataClassPathAccess,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { get_serializableProperties1162nosnaangd as get_serializableProperties } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializableProperty.mjs';
import { sortedWith13ny3qsmk2kn8 as sortedWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { get_importance2ftcvro0528ce as get_importance } from './DataClassRenderer.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  Regexxgw0gjiagf4z as Regex,
  RegexOption_IGNORE_CASE_getInstance2fmuzo7a7o03f as RegexOption_IGNORE_CASE_getInstance,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var titleFieldNames;
var pluralizeRules;
function titleCase_0(_this__u8e3s4) {
  _init_properties_Annotations_kt__sc92mm();
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  // Inline function 'kotlin.text.forEachIndexed' call
  var index = 0;
  var inductionVariable = 0;
  while (inductionVariable < charSequenceLength(_this__u8e3s4)) {
    var item = charSequenceGet(_this__u8e3s4, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    if (_unary__edvuaz > 0 && isUpperCase(item)) {
      this_0.append_58al37_k$(_Char___init__impl__6a9atx(32));
    }
    this_0.append_58al37_k$(_unary__edvuaz === 0 ? uppercaseChar(item) : item);
  }
  return this_0.toString();
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  FieldVisibility_HIDDEN_instance = new (FieldVisibility())('HIDDEN', 0);
  FieldVisibility_READ_instance = new (FieldVisibility())('READ', 1);
  FieldVisibility_EDIT_instance = new (FieldVisibility())('EDIT', 2);
}
var FieldVisibility_HIDDEN_instance;
var FieldVisibility_READ_instance;
var FieldVisibility_EDIT_instance;
var FieldVisibilityClass;
function FieldVisibility() {
  if (FieldVisibilityClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'FieldVisibility');
    FieldVisibilityClass = $;
  }
  return FieldVisibilityClass;
}
function get_description(_this__u8e3s4) {
  _init_properties_Annotations_kt__sc92mm();
  return _this__u8e3s4.annotationString_m8pucg_k$('com.lightningkite.services.data.Description', 'text');
}
function get_isMultiline(_this__u8e3s4) {
  _init_properties_Annotations_kt__sc92mm();
  return _this__u8e3s4.hasAnnotation_cpsd4h_k$('com.lightningkite.services.data.Multiline');
}
function get_hint(_this__u8e3s4) {
  _init_properties_Annotations_kt__sc92mm();
  var tmp0_elvis_lhs = _this__u8e3s4.annotationString_m8pucg_k$('com.lightningkite.services.data.Hint', 'text');
  return tmp0_elvis_lhs == null ? get_description(_this__u8e3s4) : tmp0_elvis_lhs;
}
function get_averageLength(_this__u8e3s4) {
  _init_properties_Annotations_kt__sc92mm();
  var tmp0_safe_receiver = _this__u8e3s4.annotationInt_scjdog_k$('com.lightningkite.services.data.MaxLength', 'average');
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (!(tmp0_safe_receiver === -1)) {
      tmp_0 = tmp0_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = get_maxLength(_this__u8e3s4);
    tmp_1 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver / 4 | 0;
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  return tmp_1;
}
function get_indexed(_this__u8e3s4) {
  _init_properties_Annotations_kt__sc92mm();
  var tmp0 = _this__u8e3s4.get_serializableAnnotations_8l2ro_k$();
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp;
    if (isInterface(tmp0, Collection())) {
      tmp = tmp0.isEmpty_y1axqb_k$();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (element.fqn_1 === 'com.lightningkite.services.data.Index') {
        tmp$ret$0 = true;
        break $l$block_0;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
function get_displayName(_this__u8e3s4) {
  _init_properties_Annotations_kt__sc92mm();
  // Inline function 'kotlin.collections.find' call
  var tmp0 = get_serializableAnnotations(_this__u8e3s4);
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (element.fqn_1 === 'com.lightningkite.services.data.DisplayName') {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.values_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_wei43m_k$('text');
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = tmp2_safe_receiver instanceof StringValue() ? tmp2_safe_receiver : null;
  }
  var tmp3_safe_receiver = tmp;
  var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.value_1;
  return tmp4_elvis_lhs == null ? titleCase(substringAfterLast(substringBefore(_this__u8e3s4.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), _Char___init__impl__6a9atx(60)), _Char___init__impl__6a9atx(46))) : tmp4_elvis_lhs;
}
function get_displayName_0(_this__u8e3s4) {
  _init_properties_Annotations_kt__sc92mm();
  var tmp0_elvis_lhs = _this__u8e3s4.annotationString_m8pucg_k$('com.lightningkite.services.data.DisplayName', 'text');
  return tmp0_elvis_lhs == null ? titleCase(substringAfterLast(substringBefore(_this__u8e3s4.serializer_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), _Char___init__impl__6a9atx(60)), _Char___init__impl__6a9atx(46))) : tmp0_elvis_lhs;
}
function defaultColumns(_this__u8e3s4) {
  _init_properties_Annotations_kt__sc92mm();
  // Inline function 'kotlin.collections.find' call
  var tmp0 = get_serializableAnnotations(_this__u8e3s4);
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (element.fqn_1 === 'com.lightningkite.services.data.AdminTableColumns') {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.values_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_entries_p20ztl_k$();
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : firstOrNull(tmp2_safe_receiver);
  var tmp;
  if (tmp3_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp_0 = tmp3_safe_receiver.get_value_j01efc_k$();
    tmp = tmp_0 instanceof ArrayValue() ? tmp_0 : null;
  }
  var tmp4_safe_receiver = tmp;
  var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.value_1;
  var tmp_1;
  if (tmp5_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = tmp5_safe_receiver.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
      var tmp0_safe_receiver_0 = element_0 instanceof StringValue() ? element_0 : null;
      var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.value_1;
      var tmp_2;
      if (tmp1_safe_receiver_0 == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp_3 = get_DefaultUriFormat().decodeFromString_jwu9sq_k$(Companion_instance.serializer_hd7dek_k$(_this__u8e3s4), tmp1_safe_receiver_0);
        tmp_2 = tmp_3 instanceof DataClassPath() ? tmp_3 : THROW_CCE();
      }
      var tmp0_safe_receiver_1 = tmp_2;
      if (tmp0_safe_receiver_1 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.add_utx5q5_k$(tmp0_safe_receiver_1);
      }
    }
    tmp_1 = destination;
  }
  var tmp6_elvis_lhs = tmp_1;
  var tmp_4;
  if (tmp6_elvis_lhs == null) {
    // Inline function 'kotlin.collections.sortedBy' call
    var this_0 = ensureNotNull(get_serializableProperties(_this__u8e3s4));
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_5 = defaultColumns$lambda;
    var tmp$ret$15 = new (sam$kotlin_Comparator$0())(tmp_5);
    var tmp$ret$14 = sortedWith(this_0, tmp$ret$15);
    // Inline function 'kotlin.collections.map' call
    var this_1 = take(tmp$ret$14, 5);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s_1 = this_1.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s_1.next_20eer_k$();
      var tmp$ret$18 = new (DataClassPathAccess())(new (DataClassPathSelf())(_this__u8e3s4), item);
      destination_0.add_utx5q5_k$(tmp$ret$18);
    }
    tmp_4 = destination_0;
  } else {
    tmp_4 = tmp6_elvis_lhs;
  }
  return tmp_4;
}
function get_description_0(_this__u8e3s4) {
  _init_properties_Annotations_kt__sc92mm();
  // Inline function 'kotlin.collections.find' call
  var tmp0 = _this__u8e3s4.get_serializableAnnotations_8l2ro_k$();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (element.fqn_1 === 'com.lightningkite.services.data.Description') {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.values_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_wei43m_k$('text');
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = tmp2_safe_receiver instanceof StringValue() ? tmp2_safe_receiver : null;
  }
  var tmp3_safe_receiver = tmp;
  return tmp3_safe_receiver == null ? null : tmp3_safe_receiver.value_1;
}
function get_maxLength(_this__u8e3s4) {
  _init_properties_Annotations_kt__sc92mm();
  var tmp0_safe_receiver = _this__u8e3s4.annotationInt_scjdog_k$('com.lightningkite.services.data.MaxLength', 'size');
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (!(tmp0_safe_receiver === -1)) {
      tmp_0 = tmp0_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  return tmp;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      compare_bczr_k$(a, b) {
        return this.function_1(a, b);
      }
      compare(a, b) {
        return this.compare_bczr_k$(a, b);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function defaultColumns$lambda(a, b) {
  _init_properties_Annotations_kt__sc92mm();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = get_importance(a);
  var tmp$ret$2 = get_importance(b);
  return compareValues(tmp, tmp$ret$2);
}
function FieldVisibility_HIDDEN_getInstance() {
  static_init();
  return FieldVisibility_HIDDEN_instance;
}
function FieldVisibility_READ_getInstance() {
  static_init();
  return FieldVisibility_READ_instance;
}
function FieldVisibility_EDIT_getInstance() {
  static_init();
  return FieldVisibility_EDIT_instance;
}
var properties_initialized_Annotations_kt_6uwnmc;
function _init_properties_Annotations_kt__sc92mm() {
  if (!properties_initialized_Annotations_kt_6uwnmc) {
    properties_initialized_Annotations_kt_6uwnmc = true;
    titleFieldNames = setOf(['name', 'title', 'label', 'email', 'slug', 'key']);
    // Inline function 'kotlin.collections.map' call
    var this_0 = listOf([to('person', 'people'), to('child', 'children'), to('mouse', 'mice'), to('tooth', 'teeth'), to('goose', 'geese'), to('(quiz)$', '$1zes'), to('^(ox)$', '$1en'), to('([m|l])ouse$', '$1ice'), to('(matr|vert|ind)ix|ex$', '$1ices'), to('(x|ch|ss|sh)$', '$1es'), to('([^aeiouy]|qu)y$', '$1ies'), to('(hive)$', '$1s'), to('(?:([^f])fe|([lr])f)$', '$1$2ves'), to('sis$', 'ses'), to('([ti])um$', '$1a'), to('(buffal|tomat)o$', '$1oes'), to('(bu)s$', '$1ses'), to('(alias|status)$', '$1es'), to('(octop|vir)us$', '$1i'), to('(ax|test)is$', '$1es'), to('s$', 's')]);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var pattern = item.component1_7eebsc_k$();
      var replacement = item.component2_7eebsb_k$();
      var tmp$ret$2 = to(Regex().new_kotlin_text_Regex_rhjlid_k$(pattern, RegexOption_IGNORE_CASE_getInstance()), replacement);
      destination.add_utx5q5_k$(tmp$ret$2);
    }
    pluralizeRules = destination;
  }
}
//region block: exports
export {
  get_averageLength as get_averageLength8laoo3shoyld,
  defaultColumns as defaultColumns2bko8gwvd6xmb,
  get_description_0 as get_descriptionegeezwg3tsc8,
  get_displayName as get_displayNamehv5zo902rjy4,
  get_displayName_0 as get_displayName1tigg9iilbqpf,
  get_hint as get_hint19r2vwwyh0jr3,
  get_indexed as get_indexed2rygxbbvfuc29,
  get_isMultiline as get_isMultiline1iipzhzq60rsb,
  titleCase_0 as titleCase2ywrimcithmnb,
  FieldVisibility_EDIT_getInstance as FieldVisibility_EDIT_getInstancek1g4gozfl4h,
  FieldVisibility_HIDDEN_getInstance as FieldVisibility_HIDDEN_getInstance2bb3agz7xywku,
  FieldVisibility_READ_getInstance as FieldVisibility_READ_getInstancekx1pgmq3g1h,
};
//endregion

//# sourceMappingURL=Annotations.mjs.map
